import { Product } from '~/composables';

export interface RequestQuoteFormFields {
  email: string;
  firstName: string;
  lastName: string;
  remarks?: string;
}

export interface HandleAddProductsToQuoteCart {
  product: Product;
  quantity?: number;
  bundleSelectedOptions?: Record<string, { uid: string; quantity: number }>;
  productConfiguration?: Record<string, string>;
  redirect?: boolean;
}

export enum RequestQuoteStatusMap {
  Created = 'Created',
  Pending = 'Pending',
  Approved = 'Approved',
  Complete = 'Complete',
  Canceled = 'Canceled',
  Expired = 'Expired',
  Holded = 'Holded',
  'Admin New' = 'Admin New',
  'Admin Created' = 'Admin Created',
}
